module.exports = __webpack_public_path__ + "static/media/know-more-footer.0e2c3918.png";